export enum DefaultUserKey {
    system = 'system',
    admin = 'admin',
}

export const LAST_LOGIN_TIME_NULL_STATE = 'Never'
